module.exports = __webpack_public_path__ + "img/thumbnail_AmericanAlligator_m_albino.3b1b79bd.png";